if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      // The panel can render outside .cc-main-product (on some product templates
      // it ends up hoisted to <main>), which made closest() null and threw a
      // TypeError in the constructor — the element then never upgraded, so the
      // bar never revealed. Fall back to the document so the main product
      // form/info still resolve (the main product is first in the DOM).
      this.productSection = this.closest('.cc-main-product') || document;
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      this.bindAddToCart();

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    /**
     * Single-variant panels render a real "Add to cart" button. Clicking it
     * triggers the main product form's submit button, so all of the theme's
     * existing add-to-cart logic (AJAX request, slide cart, error handling)
     * is reused rather than duplicated.
     */
    bindAddToCart() {
      const addBtn = this.querySelector('.js-sticky-atc-add');
      if (!addBtn || !this.productForm) return;

      addBtn.addEventListener('click', () => {
        const mainAddBtn = this.productForm.querySelector('[name="add"]');
        if (mainAddBtn) mainAddBtn.click();
      });
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
